import React from 'react'

export default function LogoPlay(props) {
  return (
    <svg
      width="258"
      height="78"
      className="w-full"
      viewBox="0 0 258 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.0486 54.6803L27.1282 31.0793L37.1956 29.2899L39.8595 40.642L40.553 36.2523L41.5491 31.2896L49.1787 29.5859L52.1467 40.2099L54.0429 30.1325L64.1105 28.343L58.8412 52.3728L49.5051 54.1365L46.1615 44.9981L43.4822 52.9132L34.0486 54.6803Z"
        fill="white"
      />
      <path
        d="M66.6014 28.7495L67.0353 21.1758L78.3217 19.3435L77.8878 26.9172L66.6014 28.7495ZM68.3074 54.3818L67.7653 37.6863L64.4868 38.5193L65.0927 30.6505L77.9883 28.7615L78.8138 52.5769L68.3074 54.3818Z"
        fill="white"
      />
      <path
        d="M80.5141 52.9923L80.3138 47.2142L88.727 35.7239L80.2686 37.4567L79.9812 29.1666L100.406 26.9375L100.62 33.1174L92.5678 43.0592L101.296 42.7522L101.573 50.7409L80.5141 52.9923Z"
        fill="white"
      />
      <path
        d="M103.2 51.8008L103 46.0228L111.413 34.5324L102.955 36.2653L102.667 27.975L123.092 25.7461L123.306 31.926L115.254 41.8677L123.982 41.5608L124.259 49.5495L103.2 51.8008Z"
        fill="white"
      />
      <path
        d="M126.157 52.5067L125.035 20.1499L143.002 18.0826C146.187 17.9706 148.668 18.6714 150.446 20.185C152.223 21.6988 153.162 23.8958 153.262 26.7764C153.319 28.4178 153.075 29.8182 152.529 30.9775C152.016 32.1359 151.3 33.0666 150.38 33.7696C151.699 34.2933 152.751 35.0445 153.534 36.0231C154.316 36.9681 154.74 38.412 154.807 40.3548C154.912 43.4028 154.052 45.8142 152.226 47.5889C150.4 49.3635 147.796 50.3102 144.416 50.4292L126.157 52.5067ZM135.432 31.7434L140.613 30.8434C142.498 30.7771 143.41 29.8731 143.351 28.1313C143.321 27.2939 143.055 26.6661 142.552 26.2478C142.081 25.7949 141.326 25.5867 140.286 25.6233L135.252 26.518L135.432 31.7434ZM135.86 44.0529L141.235 43.1462C143.217 43.0765 144.176 42.1038 144.112 40.228C144.051 38.4862 142.997 37.6514 140.948 37.7233L135.672 38.6267L135.86 44.0529Z"
        fill="white"
      />
      <path
        d="M156.447 24.0252L156.881 16.4514L168.167 14.6191L167.734 22.1928L156.447 24.0252ZM158.154 49.6576L157.61 32.962L154.333 33.7951L154.938 25.9261L167.834 24.0371L168.66 47.8527L158.154 49.6576Z"
        fill="white"
      />
      <path
        d="M182.354 47.8537C179.037 47.9703 176.62 47.2169 175.099 45.5937C173.577 43.9368 172.765 41.668 172.665 38.7874L172.422 31.7534L169.545 31.8546L169.946 25.4156L172.148 23.8651L172.68 19.105L182.385 16.3618L182.643 22.7783L186.98 21.8705L186.961 29.7689L182.916 30.6665L183.126 37.7655C183.182 39.3733 184.087 40.1463 185.842 40.0845C186.818 40.0503 187.799 39.1304 188.762 38.7612L188.991 46.4128C188.063 46.848 187.065 47.1849 185.999 47.4235C184.933 47.6622 183.719 47.8056 182.354 47.8537Z"
        fill="white"
      />
      <path
        d="M1.18617 60.1504L0 22.4121L11.7592 20.479L12.0997 34.9235L18.7978 24.993L31.2189 22.2114L21.0617 38.7454L34.0867 57.4325L22.4414 59.4053L13.8507 47.1903L12.5876 50.0961L12.9564 57.4353L1.18617 60.1504Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.204 61.6707L226.125 61.6679C226.138 61.6683 226.151 61.6689 226.164 61.6692C226.178 61.6698 226.191 61.6702 226.204 61.6707ZM257.599 32.1391L227.225 31.0705L228.286 0.471924C245.061 1.06206 258.185 15.2399 257.599 32.1391ZM196.85 30.0021C196.85 30.0165 196.849 30.0308 196.849 30.0453L196.85 30.0021Z"
        fill="#F8B246"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M257.599 33.9757C257.014 50.8749 242.94 64.0961 226.164 63.506L227.224 32.9073L196.851 31.8387C196.851 31.825 196.851 31.8113 196.852 31.7976L196.851 31.8387L257.599 33.9757Z"
        fill="#CE477C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.306 61.6683L224.376 61.6708C224.364 61.6704 224.353 61.6699 224.341 61.6695C224.33 61.6691 224.318 61.6687 224.306 61.6683ZM195.028 30.0023L225.403 31.0707L226.463 0.472137C209.688 -0.117997 195.614 13.1031 195.028 30.0023ZM255.777 32.1393C255.777 32.156 255.775 32.1726 255.775 32.1892L255.777 32.1393Z"
        fill="#915EF6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.354 2.30493L226.573 2.31262C226.536 2.31121 226.5 2.30987 226.462 2.30859C226.426 2.3073 226.39 2.30608 226.354 2.30493ZM195.028 31.8389L225.402 32.9075L224.341 63.5059C207.566 62.9159 194.442 48.738 195.028 31.8389ZM255.777 33.9758C255.777 33.9594 255.778 33.9431 255.778 33.9268L255.777 33.9758Z"
        fill="#2589E2"
      />
      <path
        d="M258 31.9223C258 49.5525 243.813 63.8445 226.312 63.8445C208.811 63.8445 194.623 49.5525 194.623 31.9223C194.623 14.2921 208.811 0 226.312 0C243.813 0 258 14.2921 258 31.9223Z"
        fill="#2589E2"
      />
      <path
        d="M241.007 28.6685C243.57 30.1592 243.57 33.8858 241.007 35.3764L222.425 46.1836C219.863 47.6743 216.659 45.811 216.659 42.8297L216.659 21.2153C216.659 18.234 219.863 16.3707 222.425 17.8613L241.007 28.6685Z"
        fill="white"
      />
      <path
        d="M150.402 56.8043C152.103 56.8043 153.397 57.3122 154.285 58.3279C155.188 59.3436 155.639 60.5639 155.639 61.9889C155.639 63.4139 155.188 64.6343 154.285 65.65C153.397 66.6505 152.103 67.1508 150.402 67.1508H147.536V72.4719H143.992V56.8043H150.402ZM150.244 64.0355C150.861 64.0355 151.32 63.8384 151.621 63.4443C151.922 63.035 152.073 62.5498 152.073 61.9889C152.073 61.428 151.922 60.9429 151.621 60.5336C151.32 60.1243 150.869 59.9196 150.267 59.9196H147.536V64.0355H150.244Z"
        fill="white"
      />
      <path
        d="M157.518 72.4719V56.0767H160.858V72.4719H157.518Z"
        fill="white"
      />
      <path
        d="M171.456 61.8525H174.796V72.4719H171.456V71.1302C171.094 71.6305 170.613 72.0246 170.011 72.3127C169.409 72.6007 168.777 72.7447 168.115 72.7447C166.625 72.7447 165.414 72.2293 164.481 71.1984C163.548 70.1676 163.081 68.826 163.081 67.1735C163.081 65.506 163.548 64.1568 164.481 63.1259C165.429 62.0951 166.655 61.5796 168.16 61.5796C168.807 61.5796 169.424 61.7161 170.011 61.9889C170.613 62.2618 171.094 62.6408 171.456 63.1259V61.8525ZM168.927 69.6294C169.59 69.6294 170.154 69.3869 170.62 68.9017C171.102 68.4015 171.343 67.8254 171.343 67.1735C171.343 66.4762 171.102 65.8926 170.62 65.4226C170.154 64.9375 169.582 64.6949 168.905 64.6949C168.198 64.6949 167.618 64.9375 167.167 65.4226C166.715 65.8926 166.489 66.4762 166.489 67.1735C166.489 67.8406 166.715 68.4166 167.167 68.9017C167.633 69.3869 168.22 69.6294 168.927 69.6294Z"
        fill="white"
      />
      <path
        d="M184.259 61.8525H187.848L181.347 77.7019H177.78L180.376 71.1984L176.223 61.8525H179.925L182.114 67.3555L184.259 61.8525Z"
        fill="white"
      />
    </svg>
  )
}
